import { Component, OnInit, Input, ViewChild ,ViewChildren,QueryList} from '@angular/core';
import { SelectItem } from 'primeng/api';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OrganismModel } from '../organism.model';
import { AddDepartmentComponent } from '../../../masters/add-department/add-department.component';
import { AddContactComponent } from '../../../masters/add-contact/add-contact.component';
import { AddAddressComponent } from '../../../masters/add-address/add-address.component';
import { HttpClient, HttpResponse } from '@angular/common/http';
import * as CommonConstants from '../../../utils/common.constants';
import { MasterService } from '../../../masters/master.service';
import { LegalFormModel } from '../../../masters/legal-form/legal.form.model';
import { CurrencyModel } from '../../../masters/currency/currency.model';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { LoaderService } from 'src/app/common/loader.service';
import swal from 'sweetalert2';
import { IntlTelNumberComponent } from '../../../common/intl-tel-number/intl-tel-number.component';
import { FormatnumeralPipe } from 'src/app/utils/formatnumeral.pipe';
import { SearchCountryField, TooltipLabel, CountryISO } from 'ngx-intl-tel-input';
@Component({
  selector: 'app-add-organism',
  templateUrl: './add-organism.component.html',
  styleUrls: ['./add-organism.component.scss']
})
export class AddOrganismComponent implements OnInit {
  form: FormGroup;
  partnerId: number;
  partnerType: number = CommonConstants.PARTNER_ORGANISM_TYPE;
  legalFormList: LegalFormModel[];
  currencyList: CurrencyModel[];
  submitted = false;
  category=[];
  categoryType=[];
  countries=[];
  url = '';
  // countryList=Countr
  organism: OrganismModel = new OrganismModel();
  addOrganismTitle = true;
  editOrganismTitle;
  orgCodeSeq='';
  CountryISO = CountryISO;
  @ViewChild(AddDepartmentComponent, { static: true }) organismsDepartments: AddDepartmentComponent;
  @ViewChild(AddContactComponent, { static: true }) organismsContact: AddContactComponent;
  @ViewChild(AddAddressComponent, { static: true }) organismsAddress: AddAddressComponent;
  @ViewChildren(IntlTelNumberComponent) phoneNos: QueryList<IntlTelNumberComponent>
  constructor(private formBuilder: FormBuilder, private http: HttpClient, private masterService: MasterService, 
    private toastr: ToastrService, private loaderService: LoaderService,private formatNumeralPipe: FormatnumeralPipe,private toastrService:ToastrService) { 
      this.getFromGroup(); 
    }
  ngOnInit() {
    this.organism.active = true;
    this.loadLegalForm();
    this.loadCurrency();
    this.loadCategory();
    this.loadType();
    this.loadCountry();
  }
  saveOrganism() {
    this.submitted = true;
    if (this.form.invalid) {
      return;
    }
    this.organism.staRecCode=this.organism.active ? 'A' : 'I';
    this.phoneNos.forEach(phone => {
      this.organism[phone.type]=phone.setPhoneNumberfrmInternation();
   })
    this.loaderService.display(true);
    let res = this.http.post(CommonConstants.SAVE_ORGANISM, this.organism)
      .subscribe(response => {
        this.loaderService.display(false);
        if (response['code'] == 0) {
          this.organism.orgsmId = response['result'];
          if(this.url!=null && this.organism.orgsmId!=null){
            this.saveImage(this.url,this.organism.orgsmId);
          }
          //this.toastr.success(response['message'], 'Success');
          swal.fire("Success", response['message'], 'success');
        } else {
         // this.toastr.error(response['message'], 'Error');
          swal.fire("Error", response['message'], 'error');
        }

      },
      error => {
        this.loaderService.display(false);
      })
  }

  loadLegalForm() {
    this.masterService.getLegalForm().subscribe(response => {
      if (response['code'] == 'S0000') {
        this.legalFormList = response['result'];
      }
    });

  }
  loadCurrency() {
    this.masterService.getCurrency().subscribe(response => {
      if (response['code'] == 'S0000') {
        response['result'] = response['result'].map(item => ({
          ...item,
          currencyLabel: item.curcyCode +" - "+ item.curcyDescEn }));
        this.currencyList = response['result'];
      }
    });

  }
  loadCategory(){
  this.masterService.getCategory().subscribe(response => {
    if (response && response['result']) {
      this.category =response['result'].filter(category => category.partnerType == this.partnerType);
    }
  })
  }
  loadType(){
  this.masterService.getCategoryType().subscribe(response => {
    if (response && response['result']) {
      this.categoryType  =response['result'].filter(type => type.partnerType == this.partnerType);
    }
  })
}
loadCountry(){
this.masterService.getCountry().subscribe(response => {
  if (response && response['result']) {
    this.countries = response['result'];
    let country  =this.countries.filter(type => type.cotryId == localStorage.getItem(CommonConstants.USER_COUNTRY_ID));
    this.orgCodeSeq=country[0].cotryCode+"-"+this.formatNumeralPipe.transform(country[0].orgCodeSeq);
    ;
    this.organism.orgsmCode=this.orgCodeSeq;
  }
})
}
onChangeCountry(event){
  if(event && event.cotryId){
    let country  =this.countries.filter(type => type.cotryId == event.cotryId);
    this.orgCodeSeq=country[0].cotryCode+"-"+this.formatNumeralPipe.transform(country[0].orgCodeSeq);
    this.organism.orgsmCode=this.orgCodeSeq;
    this.phoneNos.forEach(phone => {
      phone.selectedCountry=country[0].cotryCode;
   })
  }else{
    let country  =this.countries.filter(type => type.cotryId == localStorage.getItem(CommonConstants.USER_COUNTRY_ID));
    this.orgCodeSeq=country[0].cotryCode+"-"+this.formatNumeralPipe.transform(country[0].orgCodeSeq);;
    this.organism.orgsmCode=this.orgCodeSeq;
    this.phoneNos.forEach(phone => {
      phone.selectedCountry=CountryISO.France;
   })
  }
}
  /**
  * Declare form group
  *  
  */
 get f() { return this.form.controls; }
  private getFromGroup() {
    this.form = this.formBuilder.group({
      'orgsmCode': new FormControl('', Validators.compose([Validators.required, Validators.maxLength(7)])),
      'orgsmName': new FormControl('',Validators.required),
      'mobile': new FormControl(),
      'workPhone': new FormControl(),
      'workFax': new FormControl(),
      'homePage': new FormControl(),
      'comapnyEmail': new FormControl(),
      'noofemp': new FormControl(),
      'currency': new FormControl('',Validators.required),
      'legalForm': new FormControl(),
      'active': new FormControl(),
      'pacatId': new FormControl(),
      'pctypId': new FormControl(),
      'cotryId': new FormControl(),
      'city': new FormControl(),
      'mobcode': new FormControl(),
      'workcode': new FormControl(),
    })
  }
  ngAfterViewInit() {
    this.phoneNos.forEach(alertInstance => console.log(alertInstance));
  }

  printVal() { 
    this.phoneNos.forEach(phone => {
    })
  }
  phonePatchValue(){
    this.phoneNos.forEach(phone => {
    })
  }
reset(){
  this.organism=new OrganismModel();
  
}
saveImage(url:string,orgId:number){
  let imageJson={};
 // console.log(url);
  let imgData=url.split(",");
  imageJson["image"]=imgData[1];
  imageJson["partnerId"]=orgId;
  imageJson["partnerType"]=CommonConstants.PARTNER_ORGANISM_TYPE;
  imageJson["partnerTypeDesc"]="Organism";
  this.masterService.saveImage(imageJson).subscribe(res => {
    if (res['result'] && res['code'] === "0") {
      this.toastrService.success('Patient image updated Successfully');
    } else {
      this.toastrService.error('Patient image not updated Successfully');
    }
  })
}
addProfilePic(event) {
 // console.log("change");
  if (event.target.files && event.target.files[0]) {
    var reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]); // read file as data url
    reader.onload = (event) => { // called once readAsDataURL is completed
      this.url = <string>event.target["result"];
    }
  }
}
}